<template>
    <div>
        <v-layout wrap>
          <v-flex xs12 sm12>
            <v-layout wrap pt-10 v-if="carousel">
              <v-flex v-if="carousel">
                <OwlCarousel
                  :nav="false"
                  :dots="false"
                  :loop="true"
                  :autoplay="true"
                  :autoplayTimeout="3000"
                  :responsive="owlResponsive"
                >
                  <template xs12 sm10 v-for="(list, l) in carousel">
                    <v-layout wrap justify-center v-if="list" :key="l">
                      <v-flex>
                        <img
                          height="400px"
                          :src="list.img"
                          eager
                          style="object-fit: cover; cursor: pointer"
                        />
                      </v-flex>
                    </v-layout>
                  </template> </OwlCarousel
              ></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
    </div>
</template>
<script>
export default {
  data() {
    return {
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 2, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 4, nav: false },
        1920: { items: 6, nav: false },
      },
      carousel: [
        { img: require("./../../assets/slide1.png") },
        { img: require("./../../assets/slide2.png") },
        { img: require("./../../assets/slide3.png") },
        { img: require("./../../assets/slide4.png") },
      ],
    };
  },
};
</script>